<script setup lang="tsx">
import { mapState, context } from "../../context/context";
import Page from "../base/Page.vue";
import LayoutCenter from "../layout/LayoutCenter.vue";
import ContentCenter from "../layout/ContentCenter.vue";
import CallPhone from "../widget/CallPhone.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Page, LayoutCenter, ContentCenter, CallPhone },
  inheritAttrs: true
});

const props = withDefaults(defineProps<{}>(), {});

const mappedState = mapState([
  "park.phone",
  "color.fontPattern",
  "color.fontTertiaryPattern"
]);

// const robot = `${import.meta.env.YZ_IMAGE_PATH}/lb-robot.png`;
// const robotAnimate = `${import.meta.env.YZ_IMAGE_PATH}/lb-robot-animate.gif`;
const robot = `/public/images/xg/lb-robot.png`;
const robotAnimate = `/public/images/xg/lb-robot-animate.gif`;
</script>

<template>
  <Page class="unlocking">
    <LayoutCenter>
      <ContentCenter style="padding: var(--yz-padding-horizontal, 15px)">
        <div class="unlocking-img">
          <img :src="robot" />
          <img :src="robotAnimate" />
        </div>
        <div
          class="unlocking-text"
          :style="{
            color: mappedState['color.fontPattern'].value
          }"
        >
          车底翻板正在降下，请耐心等待...
        </div>
      </ContentCenter>
    </LayoutCenter>
    <CallPhone
      class="unlocking-bottom"
      :phone="mappedState['park.phone'].value || context.static.hotline"
    ></CallPhone>
  </Page>
</template>

<style scoped>
.unlocking-img {
  position: relative;
}
.unlocking-img > img:nth-child(1) {
  width: 4rem;
  height: 1.82rem;
}
.unlocking-img > img:nth-child(2) {
  position: absolute;
  top: -0.5rem;
  right: 0;
  width: 1.86rem;
  height: 1.94rem;
}
.unlocking-text {
  font-size: var(--yz-font-size, 16px);
  margin-top: 17px;
  font-weight: bold;
  text-align: center;
}
.unlocking-bottom {
  position: absolute;
  z-index: 2;
  bottom: var(--yz-padding-vertical-double, 20px);
  width: 100%;
}
</style>
